const advantages = [
  {
    id: 1,
    icon: 'ub-icon-user-1',
    title: 'landingPage.partnerPage.advantageFirst.title',
    text: 'landingPage.partnerPage.advantageFirst.text',
  },
  {
    id: 2,
    icon: 'ub-icon-chats',
    title: 'landingPage.partnerPage.advantageSecond.title',
    text: 'landingPage.partnerPage.advantageSecond.text',
  },
  {
    id: 3,
    icon: 'ub-icon-people',
    title: 'landingPage.partnerPage.advantageThird.title',
    text: 'landingPage.partnerPage.advantageThird.text',
  },
];

export default advantages;
